import { z } from 'zod';

const nameSchema = z.string();

export const validateName = (value?: string): string | undefined | boolean => {
  if (value === undefined) return false;

  const result = nameSchema.safeParse(value);
  if (!result.success) {
    return result.error.issues[0].message;
  }

  return undefined;
};

export const getChunkSizeSchema = () => {
  return z.object({
    chunk_size: z
      .union([z.string(), z.number()])
      .transform(val => Number(val))
      .refine(val => !isNaN(val), {
        message: 'Chunk size must be a number',
      })
      .refine(val => val >= 0 && val <= 10000, {
        message: 'Chunk size must be between 0 and 10000',
      }),
  });
};

export const validateChunkSize = (input?: number) => {
  if (!input) return false;
  try {
    getChunkSizeSchema().parse({ chunk_size: input });
    return false;
  } catch (error) {
    if (error instanceof z.ZodError) {
      return error.errors?.[0]?.message;
    }
    return 'Invalid Input';
  }
};

export const getChunkOverlapSizeSchema = () => {
  return z.object({
    chunk_size: z
      .union([z.string(), z.number()])
      .transform(val => Number(val))
      .refine(val => !isNaN(val), {
        message: 'Chunk size must be a number',
      })
      .refine(val => val >= 0 && val <= 1000, {
        message: 'Chunk size must be between 0 and 1000',
      }),
  });
};

export const validateChunkOverlapSize = (input?: number) => {
  if (!input) return false;
  try {
    getChunkOverlapSizeSchema().parse({ chunk_size: input });
    return false;
  } catch (error) {
    if (error instanceof z.ZodError) {
      return error.errors?.[0]?.message;
    }
    return 'Invalid Input';
  }
};

export const geLimitSizeSchema = () => {
  return z.object({
    chunk_size: z
      .union([z.string(), z.number()])
      .transform(val => Number(val))
      .refine(val => !isNaN(val), {
        message: 'Limit size must be a number',
      })
      .refine(val => val >= 0 && val <= 10, {
        message: 'Limit size must be between 0 and 10',
      }),
  });
};

export const validateLimitSize = (input?: number) => {
  if (!input) return false;
  try {
    getChunkOverlapSizeSchema().parse({ chunk_size: input });
    return false;
  } catch (error) {
    if (error instanceof z.ZodError) {
      return error.errors?.[0]?.message;
    }
    return 'Invalid Input';
  }
};

export const getThresholdSizeSchema = () => {
  return z.object({
    chunk_size: z
      .union([z.string(), z.number()])
      .transform(val => Number(val))
      .refine(val => !isNaN(val), {
        message: 'Threshold size must be a number',
      })
      .refine(val => val >= 0 && val <= 1.0, {
        message: 'Threshold size must be between 0.0 and 1.0',
      }),
  });
};

export const validateThresholdSize = (input?: number) => {
  if (!input && input !== 0) return false;
  try {
    getThresholdSizeSchema().parse({ chunk_size: input });
    return false;
  } catch (error) {
    if (error instanceof z.ZodError) {
      return error.errors?.[0]?.message;
    }
    return 'Invalid Input';
  }
};
